import React, { Component } from 'react'
import { Radio, Modal, Select, Checkbox } from 'antd'
import { inject, observer } from 'mobx-react'
import { users } from '@services/api'
import DebtForm from './DebtForm'
import CreditForm from './CreditForm'
import OneTimeCommission from './OneTimeCommission'
import MentorCommissionButton from './MentorCommissionButton'
import { COMMISSION_SELECT_STYLES } from './commissionSelectStyles'

@inject((store: any) => {
    const { popupStore, authStore, subscriptionsStore } = store

    return {
        popupStore,
        authStore,
        subscriptionsStore
    }
})
@observer
export default class CreateNewCommission extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            searchClientResults: '',
            credit: false,
            selectedClient: {},
            clientSubscription: '',
            subscription: '',
            clientAmount: '',
            commissionRate: 0,
            clientCommissions: '',
            oneTimeCommission: false,
            oldMethod: false,
            prevClientIdFromProps: '',
            allSubscriptions: [],
            searchOff: false
        }
    }

    componentDidMount() {
        const {
            popupStore: {
                info: { client_id }
            }
        } = this.props

        if (client_id) {
            this.setState({ searchOff: true })
            this.searchAndSelectClient(client_id)
        }
    }

    componentDidUpdate(prevProps) {
        const {
            popupStore: {
                info: { client_id }
            },
            agentInfo: { id }
        } = this.props
        const prevId = prevProps.agentInfo.id

        // if mount fired before the agent id was loaded, run the
        // pending search once the id becomes available
        if (client_id && id && !prevId && !this.state.selectedClient.client_id) {
            this.searchAndSelectClient(client_id)
        }
    }

    componentWillUnmount() {
        this.resetFormData()
    }

    onClose = () => {
        this.props.popupStore.togglePopup(false, null, true)
    }

    resetFormData = () => {
        this.setState({
            searchClientResults: '',
            credit: false,
            selectedClient: {},
            clientSubscription: '',
            subscription: '',
            clientAmount: '',
            commissionRate: 0,
            clientCommissions: '',
            prevClientIdFromProps: '',
            oneTimeCommission: false,
            oldMethod: false,
            searchOff: false
        })
    }

    searchClient = inputClientId => {
        const {
            agentInfo: { id }
        } = this.props

        if (inputClientId && id) {
            users.instantClientSearch({ agent_id: id, client_id: inputClientId }).then(res => {
                if (Array.isArray(res.data)) {
                    this.setState({ searchClientResults: res.data })
                }
            })
        } else {
            this.setState({ searchClientResults: '' })
        }
    }

    searchAndSelectClient = clientId => {
        const {
            agentInfo: { id }
        } = this.props
        if (clientId && id) {
            users.instantClientSearch({ agent_id: id, client_id: clientId }).then(res => {
                if (Array.isArray(res.data)) {
                    this.setState({ searchClientResults: res.data }, () => this.selectClient(clientId))
                }
            })
        }
    }

    handleFormInput = e => {
        let field = e.target.id.split('-')[1]
        let value = e.target.value

        if (field === 'clientAmount') {
            value = value.replace(/[^0-9\.]/g, '')
        }

        this.setState({ [field]: value })
    }

    // select client
    // set array of client subscriiption + specialSubscriptions. sorted: susbscription, special-susbs by date
    // state: allClientSubscriptions
    // state: subscription (first one from above array)

    selectClient = selectedId => {
        const {
            subscriptionsStore: { subscriptions }
        } = this.props
        const { searchClientResults } = this.state
        // guard: search may not have run / returned (e.g. agent id missing)
        let selectedClient =
            Array.isArray(searchClientResults) && searchClientResults.find(({ client_id }) => client_id == selectedId)
        if (!selectedClient) return
        let clientCommissions = this.getClientCommisions(selectedClient.client_id) || { commissions: [] }

        let recentClientSubscriptions = []
        let allSubscriptions = []
        let subscription
        let select_id = 1
        const done = {}
        if (selectedClient.client_subscription) {
            // store may not have this subscription yet; guard before cloning
            let fromStore = subscriptions.find(({ id }) => id === selectedClient.client_subscription.subscription_id)
            let found = fromStore ? JSON.parse(JSON.stringify(fromStore)) : null
            if (found) {
                subscription = found
                subscription.paid_at = selectedClient.client_subscription.paid_at
                subscription.user_subscription_id = selectedClient.client_subscription.id
                subscription.subscription_status = selectedClient.client_subscription.subscription_status
                subscription.recent = true
                subscription.select_id = select_id
                select_id++

                // recentClientSubscriptions.push(found) // ??
                // allSubscriptions.push(found)
                recentClientSubscriptions.push(subscription) // ??
                allSubscriptions.push(subscription)
                done[found.id] = true
            }
        }
        if (selectedClient.specialSubscriptions) {
            selectedClient.specialSubscriptions.forEach(sub => {
                // store may not have this subscription yet; guard before cloning
                let fromStore = subscriptions.find(({ id }) => id === sub.subscription_id)
                let found = fromStore ? JSON.parse(JSON.stringify(fromStore)) : null
                if (found) {
                    found.user_subscription_id = sub.id
                    found.specialSub = true
                    found.subscription_status = sub.subscription_status
                    found.dates_range = sub.dates_range
                    found.paid_at = sub.paid_at
                    found.recent = true
                    found.select_id = select_id
                    select_id++
                    recentClientSubscriptions.push(found)
                    allSubscriptions.push(found)
                    done[found.id] = true
                    if (!subscription) subscription = found
                }
            })
        }

        // also add every subscription from the client's history (e.g. canceled ones)
        // so the form dropdown can show all past subscriptions, not just the active one
        if (Array.isArray(selectedClient.client_subscription_history)) {
            selectedClient.client_subscription_history.forEach(hist => {
                // skip records already added above (active / special subs)
                let already = recentClientSubscriptions.find(s => s.user_subscription_id == hist.id)
                if (already) return
                // enrich the history record from the store to get name / select_id
                let fromStore = subscriptions.find(({ id }) => id === hist.subscription_id)
                let found = fromStore ? JSON.parse(JSON.stringify(fromStore)) : null
                if (found) {
                    found.user_subscription_id = hist.id
                    found.subscription_status = hist.subscription_status
                    found.paid_at = hist.paid_at
                    found.recent = true
                    found.select_id = select_id
                    select_id++
                    recentClientSubscriptions.push(found)
                    allSubscriptions.push(found)
                    done[found.id] = true
                    if (!subscription) subscription = found
                }
            })
        }

        subscriptions.forEach(sub => {
            if (!done[sub.id]) {
                let subCopy = JSON.parse(JSON.stringify(sub))
                subCopy.select_id = select_id
                select_id++
                allSubscriptions.push(subCopy)
            }
        })

        if (recentClientSubscriptions.length) {
            let clientSubscription = selectedClient.client_subscription || selectedClient.specialSubscriptions[0]
            this.setState({
                selectedClient: selectedClient,
                clientSubscription: clientSubscription,
                clientAmount: clientSubscription.price || subscription.price,
                subscription,
                clientCommissions,
                recentClientSubscriptions,
                allSubscriptions
            })
        } else {
            this.setState({
                selectedClient: selectedClient,
                clientSubscription: null,
                clientAmount: null,
                subscription: null,
                clientCommissions,
                recentClientSubscriptions
            })
        }
    }

    getClientCommisions = selectedClientId => {
        const { agentCommissions } = this.props

        // agentCommissions may be 'loading' or a non-array while data loads
        if (!Array.isArray(agentCommissions)) return null

        return agentCommissions.find(({ client_id }) => client_id == selectedClientId)
    }

    getProductName = (subscription = { name: '', description: { title: '' } }) => {
        // return subscription.name.includes('Best') ||
        //        subscription.name.includes('best') ?
        //        'BestCare' :
        //        subscription.name.includes('360') ?
        //        'MediWho360' :
        //        'MediWho360'

        return subscription.name.includes('360') || subscription.name == 'Mediwho'
            ? 'MediWho360'
            : subscription.name.includes('Fly')
            ? 'MediWhoFly'
            : 'BestCare'
    }

    selectSubscription = selectedId => {
        const { allSubscriptions, selectedClient } = this.state
        let subscription = allSubscriptions.find(({ select_id }) => select_id == selectedId)
        const historyItem =
            Array.isArray(selectedClient.client_subscription_history) && subscription
                ? selectedClient.client_subscription_history.find((h: any) => h.id == subscription.user_subscription_id)
                : null

        const clientAmount =
            historyItem && historyItem.price != null ? historyItem.price : subscription && subscription.price

        if (subscription && historyItem) {
            subscription = Object.assign({}, subscription, {
                current_percent: historyItem.current_percent,
                current_parent_percent: historyItem.current_parent_percent,
                paid_at: historyItem.paid_at,
                cancelled_at: historyItem.cancelled_at
            })
        }

        this.setState({
            subscription,
            clientAmount
        })
    }

    setCommissionType = e => {
        this.setState({ credit: e.target.value })
    }

    render() {
        const { agentInfo, getAgentCommissions, getAgentCommissionTotals } = this.props

        const {
            credit,
            searchClientResults,
            selectedClient,
            clientSubscription,
            clientAmount,
            subscription,
            clientCommissions,
            oneTimeCommission,
            oldMethod,
            recentClientSubscriptions,
            allSubscriptions
        } = this.state

        let percents = JSON.parse(agentInfo.percents || '{}')

        const agentType = agentInfo.parent_agency_id ? 'sub' : 'general'

        let productName = ''
        // let monthlyRate = 0
        // let advancedRate = 0

        // old:
        let commissionRate = 0
        let agentAmount = 0

        if (subscription) {
            productName = this.getProductName(subscription)
        }

        const date = new Date().toLocaleDateString('he-IS')

        const info = {
            credit,
            searchClientResults,
            clientAmount,
            subscription,
            agentInfo,
            clientSubscription,
            commissionRate,
            agentAmount,
            selectedClient,
            clientCommissions,
            oldMethod,
            // monthlyRate,
            // advancedRate,
            agentType,
            percents,
            productName,
            recentClientSubscriptions,
            allSubscriptions
        }

        return (
            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'newCommission'}
                title={`יצירת ${credit ? 'זיכוי' : 'חיוב'} חדש`}
                footer={null}
                width="720px"
            >
                {/* shared global Select styling for all commission forms (index.scss is a CSS module) */}
                <style>{COMMISSION_SELECT_STYLES}</style>
                <div style={{ ...style.column, ...style.content, paddingInline: '30px' }}>
                    <div style={{ ...style.line1 }}>
                        <div style={{ display: 'flex', marginLeft: '10px' }}>
                            <div style={{ ...style.box, ...style.rightBox }}>
                                <Checkbox
                                    disabled={oldMethod}
                                    checked={oneTimeCommission}
                                    value={oneTimeCommission}
                                    onChange={() => this.setState({ oneTimeCommission: !oneTimeCommission })}
                                />
                            </div>
                            <div style={{ ...style.box, ...style.leftBox }}>{'עמלה כללית'}</div>
                        </div>
                        {credit ? (
                            <div style={{ display: 'flex', marginLeft: '10px' }}>
                                <div style={{ ...style.box, ...style.rightBox }}>
                                    <Checkbox
                                        disabled={oneTimeCommission}
                                        checked={oldMethod}
                                        value={oldMethod}
                                        onChange={() => this.setState({ oldMethod: !oldMethod })}
                                    />
                                </div>
                                <div style={{ ...style.box, ...style.leftBox }}>{'עמלה משונתת'}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        <Radio.Group
                            value={credit}
                            onChange={this.setCommissionType}
                            style={{ display: 'flex', flexDirection: 'row-reverse' }}
                        >
                            <Radio.Button value={true}>זיכוי</Radio.Button>
                            <Radio.Button value={false}>חיוב</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div style={{ ...style.formLine }}>
                        <span>תאריך</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span>{date}</span>
                        </div>
                    </div>
                    <div style={{ ...style.formLine }}>
                        <span>שם ומזהה סוכן</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span
                                style={{ marginLeft: '30px' }}
                            >{`${agentInfo.first_name} ${agentInfo.last_name}`}</span>
                            <span>{agentInfo.id}</span>
                        </div>
                    </div>
                    <div style={{ ...style.formLine }}>
                        <span>חיפוש לקוח עפ״י מזהה</span>
                        <Select
                            showSearch
                            className="commission-select"
                            dropdownClassName="commission-dropdown"
                            onSearch={this.searchClient}
                            onChange={this.selectClient}
                            style={{ width: '70%' }}
                            defaultValue={'בחר/י לקוח'}
                            value={selectedClient.client_id}
                            disabled={this.state.searchOff}
                        >
                            {Array.isArray(searchClientResults) &&
                                searchClientResults.map((client, index) => {
                                    let clientFullName = `${client.client_first_name} ${client.client_last_name} - ${client.client_id}`
                                    return (
                                        <Select.Option
                                            key={index.toString()}
                                            value={client.client_id}
                                            title={clientFullName}
                                        >
                                            {clientFullName}
                                        </Select.Option>
                                    )
                                })}
                        </Select>
                    </div>
                    {!oneTimeCommission && allSubscriptions.length ? (
                        credit ? (
                            <CreditForm
                                info={info}
                                handleFormInput={this.handleFormInput}
                                selectSubscription={this.selectSubscription}
                                getAgentCommissions={getAgentCommissions}
                                getAgentCommissionTotals={getAgentCommissionTotals}
                                // onClose={this.onClose}
                                resetFormData={this.resetFormData}
                            />
                        ) : (
                            <DebtForm
                                info={info}
                                handleFormInput={this.handleFormInput}
                                selectSubscription={this.selectSubscription}
                                getAgentCommissions={getAgentCommissions}
                                getAgentCommissionTotals={getAgentCommissionTotals}
                                // onClose={this.onClose}
                                resetFormData={this.resetFormData}
                            />
                        )
                    ) : (
                        <OneTimeCommission
                            info={info}
                            getAgentCommissions={getAgentCommissions}
                            getAgentCommissionTotals={getAgentCommissionTotals}
                            resetFormData={this.resetFormData}
                        />
                    )}
                    <div style={{ alignSelf: 'end' }}>
                        <MentorCommissionButton balance={credit ? 'CREDIT' : 'DEBT'} info={info} />
                    </div>
                </div>
            </Modal>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    form: { width: '100%', paddingInline: '30px', margin: '30px 0' },
    line1: { display: 'flex', justifyContent: 'end', marginBottom: '10px' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    inputStyle: { width: '70%' },
    button: {
        height: '34px',
        width: '64px',
        background: 'white',
        borderRadius: '4px',
        border: 'solid #d9d9d9 1px',
        cursor: 'pointer',
        margin: '0 10px'
    },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '32px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}
